import type { UserData } from '@beat-venues/common-types';
import {
    convertDateToISODate,
    TextLink,
    UserInfo,
} from '@beat-venues/ui/react';
import { useTranslation } from 'react-i18next';

export interface UserDetailsProps {
    user: Omit<UserData, 'sfContactId'>;
    updateUserDetails: () => void;
}

export const UserDetails = ({
    user,
    updateUserDetails,
}: UserDetailsProps): JSX.Element => {
    const { t } = useTranslation();

    /**
     * TODO: this mapping could/should potentially be moved to the project
     * Translations are not a responsibility of the UI layer
     */
    const getValue = (item: string): string => {
        switch (item) {
            case 'birthdate':
                return (user as UserData)[item]?.length
                    ? convertDateToISODate(
                          (user as UserData)[item] as string,
                          '-'
                      )
                    : '-';
            case 'language':
                return (user as UserData)[item]?.length
                    ? t(`language.${(user as UserData)[item]}`)
                    : '-';
            case 'gender':
                return (user as UserData)[item]?.length
                    ? t(`genderOptions.${(user as UserData)[item]}`)
                    : '-';
            default:
                return (user as any)[item];
        }
    };

    return (
        <div className="m-auto mb-8 mt-4 flex w-full flex-col rounded-md px-4 py-9 md:bg-gray-500 md:px-12">
            <TextLink className="self-end" onClick={updateUserDetails}>
                {t('account.accountChange')}
            </TextLink>
            {user &&
                Object.keys(user)
                    .filter((item) => item !== 'email')
                    .map((item) => (
                        <UserInfo
                            key={`user-info-${item}`}
                            title={t(`userAccount.${item}`)}
                            userValue={getValue(item)}
                        />
                    ))}
        </div>
    );
};
